import * as React from "react";

import "./index.scss";

export default function ManagerFootballTeamCard(props) {
	const {element} = props;

	return (
		<div className="manager-team-card-container">
			<div className="manager-team-card-header">
				<div className="top-left">{element?.season?.name}</div>
				{/* <div className="top-right">{element?.playerCategory?.name}</div> */}
			</div>
			<div className="manager-team-card-info">
				<div className="info-image">
					<img src={require("@/assets/images/manager/club.png")} alt="" />
				</div>
				<div className="info-title">
					{/* {element?.name + " " + element?.team?.name} */}
					{element?.playerCategory?.name}
				</div>
			</div>
		</div>
	);
}
